import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 新規得意先情報
 */
export function AddCusMstInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddCusMstInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 編集得意先情報
 */
export function ChangeCusMstInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.ChangeCusMstInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検索得意先情報
 */
export function GetCusMstInfoByCode(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCusMstInfoByCode, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 削除得意先情報
 */
export function DeleteCusMstInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteCusMstInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検索得意先マスタ情報
 */
export function GetCusMstInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCusMstInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
/**
 * 得意先マスタ情報の取得(納品詳細用の検索条件)
 */
export function GetCusMstInfoSend(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCusMstInfoSend,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

